import { useCallback, useEffect, useState } from "preact/hooks";
import axios from "axios";

export default function useWebhooks() {
    const [webhooks, setWebhooks] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const fetchWebhooks = async () => {
        setIsLoading(true);
        try {
            axios.get("/webhooks/resources/webhooks").then((response) => {
                setWebhooks(response.data);
                setIsLoading(false);
            });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    };


    const updateWebhooks = async (data) =>{
        setIsLoading(true);
        try {
            const combinedData = {
                service_name: data.service,
                target_url: data.target_url
            };
            axios.post('/webhooks/resources/webhook', combinedData).
            then(response => {
                setIsLoading(false);
                fetchWebhooks();
            });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
        }
    }

    const deleteWebhook = async(data) =>{
        setIsLoading(true);
        try {
            setIsLoading(true);
            const webhook = {
                service_name: data.service_name,
            };
            await axios.delete('/webhooks/resources/webhook', {data: webhook})
            await fetchWebhooks();
        } catch (error) {
            console.error(error);
        } finally{
            setIsLoading(false);
        }
    }
       
    useEffect (() => {
        fetchWebhooks()
    }, []);

    return { webhooks, fetchWebhooks, isLoading, updateWebhooks, deleteWebhook };
}